import { useEffect, useRef, useState, useMemo, useCallback } from "react";
import "../../../node_modules/tabulator-tables/dist/css/tabulator_bootstrap4.css";
import "../../../node_modules/semantic-ui-css/components/icon.min.css";
import "./MenuGatewayMapa.css";
import { TabulatorFull as Tabulator, ColumnComponent, CellComponent, ColumnDefinition } from "tabulator-tables";
import { RequestMethod } from "../modules/services/core/_enums";
import { IGatewaysModel } from "../modules/services/core/_models";
import { getDataSetNamePBI, useHttpClient } from "../modules/services/Bundle";
import moment from "moment";
import L from "leaflet";
import { MapContainer, TileLayer, LayersControl } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import Select from "react-select";
import { useAuth } from "../modules/auth";
import { useLeafletContext } from "@react-leaflet/core";
import { useLocation } from "react-router-dom";
import { useFiltrosAtivos, FiltroGlobal } from "../../components/FiltrosGlobais";
import { start } from "repl";





const createFinalGatewayIcon = (status: string, iconData: { SVG: string, Class: string } | null): L.DivIcon => {
  const statusColor = status === 'offline' ? '#fb1404' : '#1eaa00';
  let innerHTML = '';

  // Verifica se há um ícone personalizado VÁLIDO (SVG ou Classe com conteúdo)
  if (iconData && (iconData.SVG?.trim() || iconData.Class?.trim())) {
    if (iconData.SVG) {
      // Garante que o SVG interno tenha a cor da borda
      let sanitizedSvg = iconData.SVG.replace(/fill="[^"]*"/, `fill="${statusColor}"`);
      innerHTML = `<div style="width: 20px; height: 20px; display: flex; align-items: center; justify-content: center; overflow: hidden;">${sanitizedSvg}</div>`;
    } else {
      innerHTML = `
                <span 
                    class="material-icons-outlined" 
                    style="font-family: 'Material Icons Outlined'; font-size: 20px; color: ${statusColor}; font-feature-settings: 'liga';"
                >${iconData.Class}</span>`;
    }
    // Se não houver ícone personalizado, usa o ícone padrão de gateway
  } else {
    const svgPath = encodeURI('/media/email/Gateways 1.svg');
    const iconInnerSize = Math.round(36 * 0.56);
    innerHTML = `<img src="${svgPath}" style="width:${iconInnerSize}px; height:${iconInnerSize}px; object-fit:contain;" />`;
  }

  const finalHTML = `
        <div style="
            width: 32px; height: 32px; border-radius: 50%; 
            background: #ffffff; 
            border: 3px solid ${statusColor};
            display: flex; align-items: center; justify-content: center; 
            box-shadow: 0 2px 6px rgba(0,0,0,0.4);
        ">
            ${innerHTML}
        </div>
    `;

  return L.divIcon({
    html: finalHTML,
    className: '',
    iconSize: [38, 38],
    iconAnchor: [19, 19]
  });
};


// Correção dos ícones padrão do Leaflet
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png",
});

interface IChamado {
  Status: boolean;
  IdAlertLevel: string;
  Dados: string;
  DataCriacao: string;
  Assunto: string;
  Chamado: string;
  IdWorkFlow: string;
  IdUsuarioOwner: number;
  IdUsuarioResponsible: number;
  UsuarioOwner?: string;
  UsuarioResponsible?: string;
  TotalRecords?: number;
}

// Adicionar interface para usuário
interface IUser {
  Id: number;
  Name: string;
  Email: string;
}

const GatewayTable: React.FC = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const configTableRef = useRef<HTMLDivElement>(null);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [detailsVisible, setDetailsVisible] = useState(false);
  const [selectedGateway, setSelectedGateway] = useState<IGatewaysModel | null>(null);
  const [activeTab, setActiveTab] = useState('mapa');
  const [chamadosGateway, setChamadosGateway] = useState<IChamado[]>([]);
  const mainTableRef = useRef<any>(null);
  const configTableRefInstance = useRef<any>(null);
  const mapRef = useRef<L.Map | null>(null);
  const markersGroup = useRef<L.LayerGroup | null>(null);
  const scaleControlRef = useRef<L.Control.Scale | null>(null);
  const dataSetNamePBI = getDataSetNamePBI();

  const httpClient = useHttpClient();
  const [listaGateway, setListaGateway] = useState<IGatewaysModel[]>([]);
  const [totalRegistros, setTotalRegistros] = useState<number>(0);
  const [registrosFiltrados, setRegistrosFiltrados] = useState<number>(0);


const [pendingApiCalls, setPendingApiCalls] = useState<number>(0);
const startApiCall = useCallback(() => setPendingApiCalls(n => n + 1), []);
const endApiCall   = useCallback(() => setPendingApiCalls(n => Math.max(0, n - 1)), []);
const configButtonDisabled = pendingApiCalls > 0;


  const [selectedAlert, setSelectedAlert] = useState<IChamado | null>(null);
  const [coments, setComents] = useState<any[]>([]);
  const [newComment, setNewComment] = useState<string>("");
  const [selectedGateways, setSelectedGateways] = useState<string[]>([]);
  const legendControlRef = useRef<L.Control | null>(null);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [idemail, setIdemail] = useState<number | null>(null);
  const iconCacheRef = useRef<Map<number, { SVG: string; Class: string } | null>>(new Map());
  const lastSelectedGatewayIdRef = useRef<number | null>(null);
  const iconFetchAbortRef = useRef<AbortController | null>(null);
  const fetchIconForGateway = async (IdPlace?: number | null, signal?: AbortSignal): Promise<{ SVG: string, Class: string } | null> => {
    try {
      if (!IdPlace) return null;

      // 1. VERIFICA O CACHE PRIMEIRO
      if (iconCacheRef.current.has(IdPlace)) {
        return iconCacheRef.current.get(IdPlace) || null;
      }

      const url = `${backendUrl}/api/PlaceTags/by-idsplace`;
      const resp = await fetch(url, {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth?.Token}`
        },
        body: JSON.stringify({
          IdsPlaces: [IdPlace],
          IdApp: process.env.REACT_APP_POWER_BI_APPLICATIONID
        }),
        signal
      });

      if (!resp.ok) {
        iconCacheRef.current.set(IdPlace, null); // Armazena falha no cache
        return null;
      }

      const response = await resp.json();

      if (!response.IsRequestSuccessful || !response.Data || !Array.isArray(response.Data) || response.Data.length === 0) {
        iconCacheRef.current.set(IdPlace, null);
        return null;
      }

      const first = response.Data.find((d: any) => d.IdPlace === IdPlace);
      if (!first || !first.Value) {
        iconCacheRef.current.set(IdPlace, null);
        return null;
      }

      const iconData = typeof first.Value === 'string' ? JSON.parse(first.Value) : first.Value;

      // 2. ARMAZENA O DADO VÁLIDO NO CACHE
      iconCacheRef.current.set(IdPlace, iconData);
      return iconData;

    } catch (e) {
      if ((e as Error).name !== 'AbortError') {
        console.error("Erro ao buscar dados do ícone do gateway:", e);
      }
      return null;
    }
  };
  const { selectedOrganizations, isInitialized, selectedCorporation, availableCorporations } = useFiltrosAtivos();


  const { auth } = useAuth();

  const SCREEN_CODE_TABELA_GATEWAYS = "Tabela_Gateways";
  const cacheUserId = auth?.User?.IdUsuario ?? "";

  const extractCacheJson = useCallback((response: any): any => {
    const container = response?.payload ?? response?.data ?? response;
    if (container == null) return null;
    const dataStr = typeof container === "string" ? container : (container?.Data ?? container?.data);
    if (typeof dataStr === "string") {
      try {
        return JSON.parse(dataStr);
      } catch {
        return null;
      }
    }
    if (typeof container === "object" && container !== null) return container;
    return null;
  }, []);

  const saveTableColumnsCache = useCallback(
    async (columnsVisibility: Record<string, boolean>, columnsOrder: string[]) => {
      if (!cacheUserId) return;
      try {
        let current: any = {};
        try {
          const response = await httpClient.request({
            method: RequestMethod.GET,
            endpoint: `/api/Cache/${SCREEN_CODE_TABELA_GATEWAYS}?userId=${cacheUserId}`,
          });
          current = extractCacheJson(response) || {};
        } catch {
          // ignore
        }
        const next = { ...current, columnsVisibility, columnsOrder };
        await httpClient.request({
          method: RequestMethod.POST,
          endpoint: "/api/Cache",
          data: {
            UserId: cacheUserId,
            ScreenCode: SCREEN_CODE_TABELA_GATEWAYS,
            Data: JSON.stringify(next),
          },
        });
      } catch (e) {
        console.error("Erro ao salvar cache de colunas (Tabela_Gateways).", e);
      }
    },
    [httpClient, extractCacheJson, cacheUserId]
  );
  const user = auth?.User;
  const emailUsuario = user?.Email;

  // Usar filtros globais


  // Estados locais removidos - agora usa filtros globais
  // selectedOrganizations, availableOrganizations, availableCorporations, 
  // selectedCorporation, isInitialized, userId, etc.

  // Mover o useLocation para o nível superior
  const location = useLocation();

  // Remover urlParams - não é mais necessário
  // const urlParams = useMemo(() => {
  //   const searchParams = new URLSearchParams(location.search);
  //   const orgParam = searchParams.get('org');
  //   return orgParam ? orgParam.split(',') : [];
  // }, [location.search]);

  // useEffects complexos removidos - agora usa filtros globais
  // initializeWithOrganizations, initializeUserData e processUrlParams não são mais necessários

  // Novo useEffect simplificado para carregar dados quando organizações mudarem
  useEffect(() => {
    // Só carregar o mapa quando os filtros globais estiverem inicializados
    // e houver pelo menos uma organização selecionada.
    if (!isInitialized || !mainTableRef.current) return;

    if (selectedOrganizations && selectedOrganizations.length > 0) {
      console.log('🔄 Carregando dados para organizações:', selectedOrganizations);
      obterMapaGateway(selectedOrganizations);
    } else {
      // Não chama o endpoint sem organizações — evita chamada ao endpoint genérico
      console.log('🔍 Filtros globais inicializados, porém nenhuma organização selecionada. Nenhuma requisição será feita.');
    }
  }, [selectedOrganizations, isInitialized]);







  // ✅ REMOVIDO - useEffect para sincronizar filtros do Tabulator com filtros globais
  // useEffect(() => {
  //   if (mainTableRef.current && isInitialized) {
  //     // Verificar se há filtros ativos no header filter
  //     const activeFilters = mainTableRef.current.getFilters();
  //     const organizacaoFilter = activeFilters.find((filter: any) => filter.field === "Organizacao");

  //     // Só aplicar filtro global se não houver filtro manual ativo
  //     if (!organizacaoFilter || !organizacaoFilter.value || organizacaoFilter.value.length === 0) {
  //       if (selectedOrganizations.length > 0) {
  //         console.log('🔍 Aplicando filtro de organizações no Tabulator:', selectedOrganizations);
  //         mainTableRef.current.setFilter("Organizacao", "in", selectedOrganizations);
  //       } else {
  //         // Se não há organizações selecionadas, limpar o filtro
  //         console.log('🔍 Limpando filtro de organizações no Tabulator');
  //         mainTableRef.current.clearFilter("Organizacao");
  //       }
  //     } else {
  //       console.log('🔍 Ignorando filtro global - filtro manual ativo:', organizacaoFilter.value);
  //     }
  //   }
  // }, [selectedOrganizations, isInitialized]);

  // ✅ REMOVIDO - useEffect para atualizar as opções do filtro de organizações
  // useEffect(() => {
  //   if (mainTableRef.current && listaGateway.length > 0) {
  //     // Verificar se há filtros ativos no header filter
  //     const activeFilters = mainTableRef.current.getFilters();
  //     const organizacaoFilter = activeFilters.find((filter: any) => filter.field === "Organizacao");

  //     // Filtrar organizações baseado nos dados carregados
  //     let organizacoesDisponiveis = Array.from(new Set(listaGateway.map(item => item.Organizacao)))
  //       .filter(Boolean)
  //       .sort();

  //     // Se há organizações selecionadas nos filtros globais E não há filtro manual ativo, mostrar apenas essas
  //     if (selectedOrganizations.length > 0 && (!organizacaoFilter || !organizacaoFilter.value || organizacaoFilter.value.length === 0)) {
  //       organizacoesDisponiveis = organizacoesDisponiveis.filter(org =>
  //         selectedOrganizations.includes(org)
  //       );
  //     }

  //     console.log('📋 Atualizando opções do filtro de organizações:', organizacoesDisponiveis);

  //     mainTableRef.current.updateColumnDefinition("Organizacao", {
  //       headerFilterParams: {
  //         values: organizacoesDisponiveis,
  //         multiselect: true,
  //         clearable: true,
  //       },
  //     });
  //   }
  // }, [listaGateway, selectedOrganizations]);



  async function exportTableToExcel() {
    const filteredData = mainTableRef.current.getData("active");
    const visibleColumns = mainTableRef.current.getColumns().filter((col: ColumnComponent) => col.isVisible());

    // Criar um objeto que mapeia os campos para seus títulos
    const fieldToTitle: { [key: string]: string } = {};
    visibleColumns.forEach((col: ColumnComponent) => {
      fieldToTitle[col.getField()] = col.getDefinition().title || col.getField();
    });

    // Mapear os dados usando os títulos das colunas
    const orderedData = filteredData.map((row: Record<string, any>) => {
      const orderedRow: Record<string, any> = {};
      Object.keys(row).forEach((field) => {
        if (fieldToTitle[field]) {
          orderedRow[fieldToTitle[field]] = row[field] ?? "";
        }
      });
      // Adiciona Latitude e Longitude manualmente se existirem
      if (row.Latitude !== undefined) {
        orderedRow["Latitude"] = row.Latitude;
      }
      if (row.Longitude !== undefined) {
        orderedRow["Longitude"] = row.Longitude;
      }
      return orderedRow;
    });
    console.log("ResultadoOrdenado", orderedData);
    console.log("ResultadoFiltrado", filteredData);
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const endpoint = `${backendUrl}/Report/Excel`;
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(orderedData)
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Gateways.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        console.log('Arquivo Excel baixado com sucesso!');
      } else {
        console.error('Erro ao baixar o arquivo Excel:', response.statusText);
      }
    } catch (error) {
      console.error('Erro ao fazer o POST:', error);
    }
  }

  useEffect(() => {
    startApiCall();
    const obterIdEmail = async () => {
      if (emailUsuario) {
        try {
          const response = await fetch(
            `${backendUrl}/api/User/ByEmail/${emailUsuario}`,
            {
              method: "GET",
              headers: {
                accept: "*/*",
              },
            }
          );
          const responseJson = await response.json();
          console.log("responseJson:", responseJson); // Log the response for debugging
          if (typeof responseJson === 'number') {
            setIdemail(responseJson);
          } else if (responseJson && responseJson.id) {
            setIdemail(responseJson.id);
          } else {
            console.error("ID do usuário não encontrado na resposta:", responseJson);
          }
        } catch (error) {
          console.error("Erro ao buscar ID do usuário:", error);
        }
      }
    };

    obterIdEmail();
    endApiCall();
  }, [emailUsuario]);

  // Não sobrescrever .tabulator-footer; garantir contador traduzido e posicionar o paginador
  const atualizarFooter = useCallback(() => {
    console.log("Atualizando footer (posicionar paginador) - Total:", totalRegistros, "Filtrados:", registrosFiltrados);
    if (!mainTableRef.current) return;
    try {
      const footerP = document.getElementById('footer-paginator') || mainTableRef.current.element.querySelector('#footer-paginator');
      const footerInfo = document.getElementById('footer-info') || mainTableRef.current.element.querySelector('#footer-info');
      const footerEl = mainTableRef.current.element.querySelector('.tabulator-footer');

      // Atualiza o texto do contador no footer-info (Mostrando X - Y de Z linhas)
      try {
        const pageSize = mainTableRef.current.getPageSize ? mainTableRef.current.getPageSize() : (mainTableRef.current.getOptions && mainTableRef.current.getOptions().paginationSize) || 25;
        const page = mainTableRef.current.getPage ? mainTableRef.current.getPage() : 1;
        const total = typeof totalRegistros === 'number' && totalRegistros > 0 ? totalRegistros : mainTableRef.current.getData ? mainTableRef.current.getData().length : 0;
        const start = total === 0 ? 0 : ((page - 1) * pageSize) + 1;
        const end = Math.min(total, page * pageSize);
        const statusText = `Mostrando ${start} - ${end} de ${total} linhas`;
        if (footerInfo) footerInfo.textContent = statusText;
      } catch (e) {
        // se não for possível obter paginação via API, apenas mostra total
        if (footerInfo) footerInfo.textContent = `${totalRegistros} registros`;
      }

      if (footerP && footerEl) {
        // Seleciona um paginador que não seja já o footer-paginator (evitar mover o container para dentro dele mesmo)
        const paginator = footerEl.querySelector('.tabulator-paginator:not(#footer-paginator)') || footerEl.querySelector('.tabulator-paginator');
        if (paginator && footerP !== paginator.parentElement) {
          footerP.innerHTML = '';
          footerP.appendChild(paginator);
        }
      }
    } catch (err) {
      console.warn('Erro ao posicionar paginador:', err);
    }
  }, [registrosFiltrados, totalRegistros]);

  const obterMapaGateway = async (orgs?: string[]) => {
    startApiCall();
    try {
      console.log("Iniciando obterMapaGateway com organizações:", orgs);

      // Guard: nunca chamar endpoints genéricos sem organizações.
      if (!orgs || orgs.length === 0) {
        console.log("Nenhuma organização fornecida - pulando chamada a 'ObterGatewaysByOrg'.");
        return;
      }

      // Atualizar o footer apenas posicionando o paginador (não sobrescrever)
      try { setTimeout(() => atualizarFooter(), 30); } catch (e) { }

      // Usar explicitamente o endpoint ByOrg (já temos garantido que orgs não está vazio)
      const endpoint = '/Gerenciamento/PowerBI/ObterGatewaysByOrg';

      // Cria um objeto URLSearchParams para construir a query string
      const queryParams = new URLSearchParams();
      if (dataSetNamePBI) {
        queryParams.append('datasetName', dataSetNamePBI);
      }

      console.log("Enviando organizações para API:", orgs);
      orgs.forEach(org => {
        if (org && org.trim()) queryParams.append('organization', org.trim());
      });

      // Concatena a query string ao endpoint
      const fullUrl = `${endpoint}?${queryParams.toString()}`;

      console.log("Fazendo requisição para URL:", fullUrl);

      const response = await httpClient.request({
        method: RequestMethod.GET,
        endpoint: fullUrl,
      });

      console.log("Resposta da API:", response);

      if (response.success && response.payload) {
        console.log(`Recebidos ${response.payload.length} registros da API`);

        // Atualizar o estado com os novos dados
        setListaGateway(response.payload);
        const novoTotal = response.payload.length;
        setTotalRegistros(novoTotal);
        // Inicialmente, registros filtrados = total (será atualizado pelo dataFiltered event)
        setRegistrosFiltrados(novoTotal);

        // Atualizar a tabela se ela existir
        if (mainTableRef.current) {
          console.log("Atualizando tabela com", response.payload.length, "registros");
          // usa setData para garantir que o Tabulator reconstrua a paginação se necessário
          mainTableRef.current.setData(response.payload)
            .then(() => {
              // redraw para forçar renderização e criação do paginador
              try { mainTableRef.current.redraw(true); } catch (e) { }
              // garantir posicionamento do paginador
              setTimeout(() => atualizarFooter(), 80);
            })
            .catch((err: any) => console.error('Erro ao setData:', err));
        }
      } else {
        console.error("Resposta da API não contém dados válidos:", response);
        throw new Error("Falha ao obter dados dos gateways");
      }
    } catch (error: any) {
      console.error("Erro ao obter lista de gateways:", error);
    }
    finally {endApiCall()}
  };


  const handleFecharChamado = async (idWorkFlow: number) => {
    try {
      const response = await fetch(`${backendUrl}/api/PlaceWorkflow/Close`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          IdWorkFlow: idWorkFlow,
          Close: true
        }),
      });
      if (response.ok) {
        alert("Chamado fechado com sucesso!");
        // Atualiza o estado do chamado selecionado para fechado
        setSelectedAlert(prev => prev ? { ...prev, Status: true } : prev);
      } else {
        alert("Erro ao fechar chamado.");
      }
    } catch (error) {
      alert("Erro ao fechar chamado.");
      console.error(error);
    }
  };

  const loadConfigTable = () => {
    const cols = mainTableRef.current
      .getColumns()
      .map((col: ColumnComponent, index: number) => ({
        id: index + 1,
        title: col.getDefinition().title || col.getField(),
        field: col.getField(),
        visible: col.isVisible(),
      }));

    if (configTableRef.current) {
      if (configTableRefInstance.current) {
        configTableRefInstance.current.destroy();
      }

      configTableRefInstance.current = new Tabulator(configTableRef.current, {
        data: cols,
        layout: "fitDataFill",
        movableRows: true,
        headerVisible: false,
        columns: [
          {
            title: "Mover",
            formatter: "handle",
            headerSort: false,
            width: 30,
            minWidth: 30,
          },
          {
            title: "Coluna",
            field: "title",
            formatter: (cell) => ` ${cell.getValue()}`,
          },
          {
            title: "Visível",
            field: "visible",
            formatter: "tickCross",
            editor: true,
          },
        ],
      });

      // Forçar atualização da tabela principal
      mainTableRef.current.redraw();
    }
  };

  // Funções auxiliares
  const deltaTime = (minutes: number) => {
    const MINUTES_IN_HOUR = 60;
    const HOURS_IN_DAY = 24;
    const DAYS_IN_MONTH = 30;

    const months = Math.floor(minutes / (MINUTES_IN_HOUR * HOURS_IN_DAY * DAYS_IN_MONTH));
    minutes %= MINUTES_IN_HOUR * HOURS_IN_DAY * DAYS_IN_MONTH;

    const days = Math.floor(minutes / (MINUTES_IN_HOUR * HOURS_IN_DAY));
    minutes %= MINUTES_IN_HOUR * HOURS_IN_DAY;

    const hours = Math.floor(minutes / MINUTES_IN_HOUR);
    const remainingMinutes = minutes % MINUTES_IN_HOUR;

    const M = months ? `${months} M, ` : '';
    const D = days ? `${days} d, ` : '';
    const H = hours ? `${hours} h e ` : '';
    const I = `${remainingMinutes} min`;

    return `${M}${D}${H}${I}`;
  };

  // Editor personalizado para filtro de duração
  const durationFilterEditor = (cell: any, onRendered: any, success: any, cancel: any) => {
    const container = document.createElement("span");

    const start = document.createElement("input");
    start.setAttribute("type", "number");
    start.setAttribute("placeholder", "Min");
    start.style.padding = "4px";
    start.style.width = "32%";

    const end = start.cloneNode() as HTMLInputElement;
    end.setAttribute("placeholder", "Max");

    const lista = document.createElement('select');
    lista.style.width = "32%";
    lista.style.padding = "2px";

    ['Minutos', 'Horas', 'Dias', 'Meses'].forEach(opt => {
      const option = document.createElement('option');
      option.value = opt.toLowerCase();
      option.text = opt;
      lista.appendChild(option);
    });

    const buildValues = () => {
      success({
        start: start.value,
        end: end.value,
        unit: lista.value
      });
    };

    [start, end, lista].forEach(el => {
      el.addEventListener("change", buildValues);
      el.addEventListener("blur", buildValues);
    });

    container.appendChild(start);
    container.appendChild(end);
    container.appendChild(lista);

    return container;
  };

  // Editor personalizado para filtro de data
  const dateEditor = (cell: any, onRendered: any, success: any, cancel: any) => {
    const container = document.createElement("span");

    // Criar inputs de data
    const date2 = document.createElement("input");
    date2.setAttribute("type", "date");
    date2.style.padding = "3px";
    date2.style.width = "50%";
    date2.style.fontSize = "12px";
    date2.style.boxSizing = "border-box";

    const date1 = date2.cloneNode() as HTMLInputElement;

    // Configurar datas iniciais
    const hoje = new Date();
    date2.value = hoje.toISOString().split('T')[0];

    const dataAnterior = new Date();
    dataAnterior.setFullYear(dataAnterior.getFullYear() - 1);
    date1.value = dataAnterior.toISOString().split('T')[0];

    const buildValues = () => {
      success({
        date1: date1.value,
        date2: date2.value,
      });
    };

    const keypress = (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        buildValues();
      }
      if (e.key === "Escape") {
        cancel();
      }
    };

    // Adicionar event listeners
    [date1, date2].forEach(el => {
      el.addEventListener("change", buildValues);
      el.addEventListener("blur", buildValues);
      el.addEventListener("keydown", keypress);
    });

    container.appendChild(date1);
    container.appendChild(date2);

    return container;
  };

  // Função de filtro para datas
  const dateFilterFunction = (headerValue: any, rowValue: any) => {
    // Se não há filtro definido, mostra todos os registros
    if (!headerValue || (!headerValue.date1 && !headerValue.date2)) return true;

    // Se o valor da linha é vazio/nulo, não mostra
    if (!rowValue) return false;

    // Função para normalizar qualquer formato de data para Date
    const normalizeDate = (dateValue: string | Date) => {
      // Se já é um objeto Date, retorna diretamente
      if (dateValue instanceof Date) return dateValue;

      // Tenta parsear formato DD/MM/YYYY HH:mm:ss
      const dateTimeMatch = String(dateValue).match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
      if (dateTimeMatch) {
        const [_, day, month, year, hours, minutes, seconds] = dateTimeMatch;
        return new Date(
          parseInt(year),
          parseInt(month) - 1,
          parseInt(day),
          parseInt(hours),
          parseInt(minutes),
          parseInt(seconds)
        );
      }

      // Tenta parsear como ISO
      const date = new Date(dateValue);
      return isNaN(date.getTime()) ? null : date;
    };

    // Normaliza a data da linha
    const rowDate = normalizeDate(rowValue);
    if (!rowDate) return false;

    // Normaliza as datas do filtro
    const startDate = headerValue.date1 ? new Date(headerValue.date1) : null;
    const endDate = headerValue.date2 ? new Date(headerValue.date2) : null;


    if (endDate) {
      endDate.setDate(endDate.getDate() + 1);
    }

    // Se não há datas no filtro, mostra tudo
    if (!startDate && !endDate) return true;

    // Ajusta o range do filtro
    const startOfDay = startDate ? new Date(startDate) : null;
    const endOfDay = endDate ? new Date(endDate) : null;

    if (startOfDay) startOfDay.setHours(0, 0, 0, 0);
    if (endOfDay) endOfDay.setHours(23, 59, 59, 999);

    // Caso 1: Mesma data em ambos os campos (filtro para um único dia)
    if (startDate && endDate && startDate.toDateString() === endDate.toDateString()) {
      return rowDate >= startOfDay! && rowDate <= endOfDay!;
    }

    // Caso 2: Apenas data inicial definida
    if (startDate && !endDate) {
      return rowDate >= startOfDay!;
    }

    // Caso 3: Apenas data final definida
    if (!startDate && endDate) {
      return rowDate <= endOfDay!;
    }

    // Caso 4: Intervalo de datas definido
    if (startDate && endDate) {
      return rowDate >= startOfDay! && rowDate <= endOfDay!;
    }

    return true;
  };

  // Adicione este editor personalizado para o filtro de temperatura após a função dateFilterFunction
  const temperatureFilterEditor = (cell: any, onRendered: any, success: any, cancel: any) => {
    const container = document.createElement("span");

    const min = document.createElement("input");
    min.setAttribute("type", "number");
    min.setAttribute("placeholder", "Min °C");
    min.style.padding = "4px";
    min.style.width = "48%";
    min.style.marginRight = "4%";

    const max = document.createElement("input");
    max.setAttribute("type", "number");
    max.setAttribute("placeholder", "Max °C");
    max.style.padding = "4px";
    max.style.width = "48%";

    const buildValues = () => {
      success({
        min: min.value ? parseFloat(min.value) : null,
        max: max.value ? parseFloat(max.value) : null,
      });
    };

    [min, max].forEach(el => {
      el.addEventListener("change", buildValues);
      el.addEventListener("blur", buildValues);
    });

    container.appendChild(min);
    container.appendChild(max);

    return container;
  };


  const createInputFilterEditor = (field: keyof IGatewaysModel) => (cell: any, onRendered: any, success: any, cancel: any) => {
    const container = document.createElement("div");
    container.style.position = "relative"; // Garante que a lista seja posicionada corretamente

    // Input para digitar o filtro
    const input = document.createElement("input");
    input.setAttribute("type", "text");
    input.setAttribute("placeholder", "Buscar...");
    input.classList.add("filter-input"); // Adiciona a classe do input

    // Lista de sugestões
    const suggestionList = document.createElement("div");
    suggestionList.classList.add("suggestion-list"); // Adiciona a classe da lista
    suggestionList.style.position = "absolute";
    suggestionList.style.top = "100%";
    suggestionList.style.left = "0";
    suggestionList.style.right = "0";
    suggestionList.style.zIndex = "1000"; // Aumente o z-index
    suggestionList.style.maxHeight = "200px";
    suggestionList.style.overflowY = "auto";
    suggestionList.style.display = "none";

    // Adiciona a lista de sugestões ao body
    document.body.appendChild(suggestionList);

    // Função para atualizar a lista de sugestões
    const updateSuggestions = (filterText: string) => {
      const tableData = mainTableRef.current.getData(); // Acessa os dados da tabela
      const uniqueValues = Array.from(new Set(tableData.map((item: any) => item[field])));
      const filteredValues = uniqueValues.filter((value: any) =>
        value?.toString().toLowerCase().includes(filterText.toLowerCase())
      );

      suggestionList.innerHTML = ""; // Limpa a lista atual
      filteredValues.forEach((value) => {
        const suggestionItem = document.createElement("div");
        suggestionItem.textContent = String(value);
        suggestionItem.classList.add("suggestion-item"); // Adiciona a classe do item
        suggestionItem.addEventListener("click", () => {
          input.value = String(value); // Preenche o input com o valor selecionado
          suggestionList.style.display = "none"; // Oculta a lista
          success(value); // Aplica o filtro
        });
        suggestionList.appendChild(suggestionItem);
      });

      if (filteredValues.length > 0) {
        suggestionList.style.display = "block"; // Mostra a lista
      } else {
        suggestionList.style.display = "none"; // Oculta a lista se não houver sugestões
      }
    };

    // Evento de digitação no input
    input.addEventListener("input", (e) => {
      const filterText = (e.target as HTMLInputElement).value;
      updateSuggestions(filterText);

      // Atualiza a posição da lista de sugestões
      const rect = input.getBoundingClientRect();
      suggestionList.style.top = `${rect.bottom + window.scrollY}px`;
      suggestionList.style.left = `${rect.left + window.scrollX}px`;
      suggestionList.style.width = `${rect.width}px`;
    });

    // Evento de foco no input
    input.addEventListener("focus", () => {
      updateSuggestions(input.value);

      // Atualiza a posição da lista de sugestões
      const rect = input.getBoundingClientRect();
      suggestionList.style.top = `${rect.bottom + window.scrollY}px`;
      suggestionList.style.left = `${rect.left + window.scrollX}px`;
      suggestionList.style.width = `${rect.width}px`;
    });

    // Evento de clique fora do input (para ocultar a lista)
    document.addEventListener("click", (e) => {
      if (!container.contains(e.target as Node)) {
        suggestionList.style.display = "none";
      }
    });

    container.appendChild(input);

    return container;
  };
  const createInputFilterFunction = (field: string) => (headerValue: string, rowValue: string) => {
    if (!headerValue) return true; // Se não houver filtro, mostra todas as linhas
    return rowValue?.toString().toLowerCase().includes(headerValue.toLowerCase());
  };




  // Modificar a função addMarkerToMap
  const addMarkerToMap = (data: IGatewaysModel) => {
    if (!mapRef.current || !data.Latitude || !data.Longitude) return;

    if (!markersGroup.current) {
      markersGroup.current = L.layerGroup().addTo(mapRef.current);
    } else {
      markersGroup.current.clearLayers();
    }

    lastSelectedGatewayIdRef.current = data.IdGateway;

    // 1. Cria e exibe o ícone de fallback (padrão com cor de status)
    const fallbackIcon = createFinalGatewayIcon(data.Status, null);
    const marker = L.marker([data.Latitude, data.Longitude], {
      icon: fallbackIcon,
      zIndexOffset: 2000
    });

    const ajustarHorario = (dataStr: string | null | undefined): string => {
      if (!dataStr) return "-";
      const date = moment(dataStr);
      return date.isValid() ? date.subtract(3, 'hours').format("DD/MM/YYYY HH:mm:ss") : "-";
    };
    const popup = L.popup().setContent(`
        <b>Gateway:</b> ${data.Gateway}<br>
        <b>Local:</b> ${data.Local || "-"}<br>
        <b>Status:</b> ${data.Status || "-"}<br>
        <b>Última Atualização:</b> ${ajustarHorario(data.UltimaAtualizacao)}
    `);

    marker.bindPopup(popup).openPopup();
    markersGroup.current.addLayer(marker);
    mapRef.current.setView([data.Latitude, data.Longitude], 15);

    // 2. Tenta buscar os dados do ícone personalizado
    try {
      if (iconFetchAbortRef.current) iconFetchAbortRef.current.abort();
      const controller = new AbortController();
      iconFetchAbortRef.current = controller;

      fetchIconForGateway(data.IdGateway, controller.signal) // Renomeamos esta função, mas a chamada continua igual
        .then((iconData) => {
          if (controller.signal.aborted || lastSelectedGatewayIdRef.current !== data.IdGateway) return;

          // 3. Se encontrou dados, recria o ícone com a cor de status + ícone customizado
          if (iconData) {
            const customIconWithStatus = createFinalGatewayIcon(data.Status, iconData);
            marker.setIcon(customIconWithStatus);
          }
        });
    } catch (e) {
      console.error("Erro ao iniciar busca pelo ícone do gateway:", e);
    }
  };

  // Adicione esta função para lidar com o clique na linha
  const handleRowClick = (e: Event, row: any) => {
    const data = row.getData();
    console.log("Dados do gateway selecionado:", data);
    console.log("Latitude:", data.Latitude);
    console.log("Longitude:", data.Longitude);
    console.log("Tipo de local:", data.PlaceType);

    // Desmarcar todas as linhas selecionadas anteriormente
    const rows = mainTableRef.current.getRows();
    mainTableRef.current.deselectRow();
    rows.forEach((r: any) => {
      r.getElement().style.backgroundColor = null;
    });

    // Aplicar estilo especial para linhas offline
    if (data.Status === "offline") {
      row.getElement().style.backgroundColor = "#854b57"; // Fundo avermelhado para offline
    }

    // Selecionar a linha atual
    mainTableRef.current.selectRow(row);

    setSelectedGateway(data);
    setDetailsVisible(true);
    obterChamadosGateway(data.Gateway);

    if (data.Latitude && data.Longitude && mapRef.current && markersGroup.current) {
      addMarkerToMap(data);
    } else {
      console.warn("Dados faltando para mostrar no mapa:", {
        temLatitude: !!data.Latitude,
        temLongitude: !!data.Longitude,
        temMapRef: !!mapRef.current,
        temMarkersGroup: !!markersGroup.current
      });
    }
  };

  // Adicionar função para buscar usuário
  const obterUsuario = async (idUser: number) => {
    try {
      const response = await fetch(
        `${backendUrl}/api/User/${idUser}`,
        {
          method: "GET",
        }
      );
      if (response.ok) {
        const userData = await response.json();
        return userData;
      }
      return null;
    } catch (error) {
      console.error("Erro ao buscar usuário:", error);
      return null;
    }
  };

  // Modificar a função obterChamadosGateway para incluir os nomes dos usuários
  const obterChamadosGateway = async (gateway: string) => {
    try {
      const response = await fetch(`${backendUrl}/api/PlaceWorkFlow/ByGatewayName/${gateway}`, {
        method: 'GET',
        headers: {
          'Accept': '*/*',
        },
      });

      if (response.ok) {
        const data = await response.json();
        // Filtra os dados com base no selectedGateway
        const filteredData = data.filter((item: any) => {
          try {
            const parsedData = JSON.parse(item.Dados);
            return parsedData.Gateway === gateway;
          } catch (e) {
            console.error('Erro ao parsear JSON:', e);
            return false;
          }
        });

        // Buscar nomes dos usuários para cada chamado
        const chamadosComUsuarios = await Promise.all(
          filteredData.map(async (chamado: any) => {
            const [usuarioOwner, usuarioResponsible] = await Promise.all([
              obterUsuario(chamado.IdUsuarioOwner),
              obterUsuario(chamado.IdUsuarioResponsible)
            ]);

            return {
              ...chamado,
              UsuarioOwner: usuarioOwner?.Name || 'Não identificado',
              UsuarioResponsible: usuarioResponsible?.Name || 'Não atribuído',
              TotalRecords: chamado.TotalRecords || 0
            };
          })
        );

        setChamadosGateway(chamadosComUsuarios);
      } else {
        console.error('Erro ao buscar dados:', response.statusText);
      }
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    }
  };

  // Adicionar nova função para buscar comentários
  const obterComentarios = async (idWorkFlow: string) => {
    try {
      const response = await fetch(
        `${backendUrl}/api/PlaceWorkFlowUser/ByWorkFlow/${idWorkFlow}`,
        {
          method: "GET",
        }
      );
      const responseJson = await response.json();

      // Buscar os dados do usuário para cada comentário
      const comentariosComUsuarios = await Promise.all(
        responseJson.map(async (comentario: any) => {
          const usuario = await obterUsuario(comentario.IdUser);
          return {
            ...comentario,
            Name: usuario?.Name || 'Usuário não identificado'
          };
        })
      );

      setComents(comentariosComUsuarios);
    } catch (error) {
      console.error("Erro ao buscar comentários:", error);
    }
  };

  // Adicionar função para incluir comentário
  const handleIncluirComentario = async () => {
    if (selectedAlert && newComment) {
      const comentario = {
        IdUser: idemail,
        IdPlaceWorkflow: parseInt(selectedAlert.IdWorkFlow),
        Comments: newComment, // Inclui o texto do comentário
        DtCriacao: new Date().toISOString(),
        DtAlteracao: new Date().toISOString(),
      };

      try {
        const response = await fetch(
          `${backendUrl}/api/PlaceWorkFlowUser`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(comentario),
          }
        );

        if (response.ok) {
          const responseJson = await response.json();

          // Buscar o nome do usuário pelo ID
          const userResponse = await fetch(`${backendUrl}/api/User/${idemail}`);
          if (userResponse.ok) {
            const userData = await userResponse.json();
            const adjustedDate = moment(comentario.DtCriacao).add(3, 'hours').toISOString();

            // Atualiza o estado dos comentários em tempo real
            setComents((prevComents) => [
              {
                ...responseJson,
                Comments: newComment, // Adiciona o texto do comentário enviado
                Name: userData?.Name || "Usuário não identificado", // Adiciona o nome do usuário
                DtCriacao: adjustedDate, // Usa a data de criação do comentário
              },
              ...prevComents, // Mantém os comentários existentes
            ]);

            // Limpa o campo de comentário
            setNewComment("");
            alert("Comentário incluído com sucesso!");
          } else {
            console.error("Erro ao buscar nome do usuário:", await userResponse.text());
          }
        } else {
          console.error("Erro ao incluir comentário:", await response.json());
        }
      } catch (error) {
        console.error("Erro ao incluir comentário:", error);
      }
    } else {
      alert("Comentário não pode estar vazio");
    }
  };

  // Funções removidas - agora usa filtros globais
  // fetchUserId e fetchUserOrganizations não são mais necessárias

  // Função para verificar se é um refresh da página
  const isPageRefresh = () => {
    const navigationEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
    return navigationEntry.type === 'reload';
  };

  const getBaseColumns = (): ColumnDefinition[] => [
    {
      title: "Organização",
      field: "Organizacao",
      headerFilter: "list",
      headerFilterParams: {
        values: true,
        multiselect: true,
        clearable: true,
        sort: "asc"
      },
      headerFilterFunc: (headerValue: any, rowValue: any) => {
        if (!headerValue || headerValue.length === 0) return true;
        if (Array.isArray(headerValue)) {
          return headerValue.includes(rowValue);
        }
        return headerValue === rowValue;
      },
      headerFilterPlaceholder: "Selecione...",
      width: 200,
      sorter: "string"
    },
    {
      title: "Local",
      field: "Local",
      sorter: "string",
      headerFilter: "list",
      headerFilterParams: {
        values: true,
        multiselect: true,
        clearable: true,
        sort: "asc"
      },
      headerFilterFunc: (headerValue: any, rowValue: any) => {
        if (!headerValue || headerValue.length === 0) return true;
        if (Array.isArray(headerValue)) {
          return headerValue.includes(rowValue);
        }
        return headerValue === rowValue;
      },
      headerFilterPlaceholder: "Selecione...",
      width: 200,
    },
    {
      title: "Local Fixo/Movel",
      field: "PlaceType",
      headerFilter: "list",
      headerFilterParams: {
        values: ["Fixo", "Movel"],
        multiselect: true,
        clearable: true,
        sort: "asc"
      },
      headerFilterFunc: (headerValue: any, rowValue: any) => {
        if (!headerValue || headerValue.length === 0) return true;
        if (Array.isArray(headerValue)) {
          return headerValue.includes(rowValue);
        }
        return headerValue === rowValue;
      },
      formatter: (cell: CellComponent) => {
        // Nova implementação do formatador com ícones mais simples
        const value = cell.getValue();
        if (value === "Fixo") {
          return '<span style="white-space: nowrap;"><i class="building icon" style="color: #1e136c;"></i> Fixo</span>';
        } else {
          return '<span style="white-space: nowrap;"><i class="car icon" style="color: #1e136c;"></i> Movel</span>';
        }
      },
    },
    {
      title: "Tempo decorrido",
      field: "TempoDecorrido",
      headerFilter: durationFilterEditor,
      headerFilterFunc: (headerValue: any, rowValue: any) => {
        if (!headerValue || !headerValue.start) return true;

        const minutes = parseInt(rowValue);
        if (isNaN(minutes)) return false;

        let compareValue = minutes;
        if (headerValue.unit === "horas") {
          compareValue = minutes / 60;
        } else if (headerValue.unit === "dias") {
          compareValue = minutes / (60 * 24);
        }
        else if (headerValue.unit === "meses") {
          compareValue = minutes / (60 * 24 * 30);
        }

        const start = parseInt(headerValue.start);
        const end = parseInt(headerValue.end);

        if (start && end) {
          return compareValue >= start && compareValue <= end;
        } else if (start) {
          return compareValue >= start;
        } else if (end) {
          return compareValue <= end;
        }
        return true;
      },
      formatter: (cell: any) => deltaTime(cell.getValue()),
    },
    {
      title: "Tempo de alerta", // ALTERADO
      field: "TempoDeCarencia",
      formatter: (cell) => {
        const totalMinutes = cell.getValue();
        const months = Math.floor(totalMinutes / (60 * 24 * 30));
        const days = Math.floor(
          (totalMinutes % (60 * 24 * 30)) / (60 * 24)
        );
        const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
        const minutes = totalMinutes % 60;

        const M = months ? `${months} M, ` : '';
        const D = days ? `${days} d, ` : '';
        const H = hours ? `${hours} h e ` : '';
        const I = `${minutes} min`;

        return `${M}${D}${H}${I}`;
      },
    },
    {
      title: "Tempo decorrido do Alerta", // ALTERADO
      field: "MinutosDeAlerta",
      formatter: (cell) => {
        const totalMinutes = cell.getValue();
        const months = Math.floor(totalMinutes / (60 * 24 * 30));
        const days = Math.floor(
          (totalMinutes % (60 * 24 * 30)) / (60 * 24)
        );
        const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
        const minutes = totalMinutes % 60;

        const M = months ? `${months} M, ` : '';
        const D = days ? `${days} d, ` : '';
        const H = hours ? `${hours} h e ` : '';
        const I = `${minutes} min`;

        return `${M}${D}${H}${I}`;
      },
    },
    {
      title: "Gateway",
      field: "Gateway",
      sorter: "string",
      headerFilter: "list",
      headerFilterParams: {
        values: true,
        multiselect: true,
        clearable: true,
        sort: "asc"
      },
      headerFilterFunc: (headerValue: any, rowValue: any) => {
        if (!headerValue || headerValue.length === 0) return true;
        if (Array.isArray(headerValue)) {
          return headerValue.includes(rowValue);
        }
        return headerValue === rowValue;
      },
      headerFilterPlaceholder: "Selecione...",
      formatter: (cell: CellComponent) => {
        const gateway = cell.getValue();
        return `
                <a href='/detalhes-do-gateway?gateway=${gateway}' target='_blank' style='margin-right: 10px;'>
                  <i class='ui icon external alternate' style='cursor: pointer;'></i>
                </a>
                ${gateway}
              `;
      },
    },
    {
      title: "Descrição do Local",
      field: "LocalDescricao",
      sorter: "string",
      headerFilter: "list",
      headerFilterParams: {
        values: true,
        multiselect: true,
        clearable: true,
        sort: "asc"
      },
      headerFilterFunc: (headerValue: any, rowValue: any) => {
        if (!headerValue || headerValue.length === 0) return true;
        if (Array.isArray(headerValue)) {
          return headerValue.includes(rowValue);
        }
        return headerValue === rowValue;
      },
      headerFilterPlaceholder: "Selecione...",
    },
    {
      title: "Situação",
      field: "LocalSituacao",
      headerFilter: "list",
      headerFilterParams: {
        values: ["Habilitado", "Desabilitado"],
        multiselect: true,
        clearable: true,
        sort: "asc"
      },
      headerFilterFunc: (headerValue: any, rowValue: any) => {
        if (!headerValue || headerValue.length === 0) return true;
        if (Array.isArray(headerValue)) {
          return headerValue.includes(rowValue);
        }
        return headerValue === rowValue;
      },
      formatter: (cell: CellComponent) => {
        const value = String(cell.getValue() || '').toLowerCase();
        return value.startsWith('habil')
          ? "<i class='ui green toggle on icon'></i> Habilitado"
          : "<i class='ui red toggle off icon'></i> Desabilitado";
      },
      hozAlign: "center",
    },
    {
      title: "Status",
      field: "Status",
      headerFilter: "list",
      headerFilterParams: {
        values: ["online", "offline"],
        multiselect: true,
        clearable: true,
        sort: "asc"
      },
      headerFilterFunc: (headerValue: any, rowValue: any) => {
        if (!headerValue || headerValue.length === 0) return true;
        if (Array.isArray(headerValue)) {
          return headerValue.includes(rowValue);
        }
        return headerValue === rowValue;
      },
      formatter: (cell: CellComponent) => {
        const status = cell.getValue();

        if (status === "online") {
          return '<span><i class="ui icon info circle" style="color: green; padding: 2px"></i>Online</span>';
        } else {
          return '<span><i class="ui icon exclamation triangle" style="color: red; padding: 2px"></i>Offline</span>';
        }
      },
      hozAlign: "center",
    },
    {
      title: "Ultima Atualização",
      field: "UltimaAtualizacao",
      headerFilter: dateEditor,
      headerFilterFunc: dateFilterFunction,
      sorter: (a: string, b: string) => {
        const toTimestamp = (dateTimeStr: string) => {
          const match = dateTimeStr.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
          if (match) {
            const [_, day, month, year, hours, mins, secs] = match;
            return new Date(
              parseInt(year),
              parseInt(month) - 1,
              parseInt(day),
              parseInt(hours),
              parseInt(mins),
              parseInt(secs)
            ).getTime();
          }

          // Tenta formato ISO
          const isoDate = new Date(dateTimeStr);
          return isNaN(isoDate.getTime()) ? 0 : isoDate.getTime();
        };

        const timeA = a ? toTimestamp(a) : 0;
        const timeB = b ? toTimestamp(b) : 0;
        return timeA - timeB;
      },
      formatter: (cell: any) => {
        const value = cell.getValue();
        if (!value) return " - ";

        if (typeof value === 'string' && value.match(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)) {
          const match = value.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
          if (match) {
            const [_, day, month, year, hours, mins, secs] = match;
            const date = moment(
              new Date(
                parseInt(year),
                parseInt(month) - 1,
                parseInt(day),
                parseInt(hours),
                parseInt(mins),
                parseInt(secs)
              )
            ).subtract(3, 'hours');
            return date.format("DD/MM/YYYY HH:mm:ss");
          }
          return value;
        }

        const date = moment(value);
        return date.isValid() ? date.subtract(3, 'hours').format("DD/MM/YYYY HH:mm:ss") : "N/A";
      },
    },
    {
      title: "Temperatura (°C)",
      field: "Temperature",
      sorter: "number",
      headerFilter: temperatureFilterEditor,
      headerFilterFunc: (headerValue: any, rowValue: any) => {
        if (!headerValue || (!headerValue.min && !headerValue.max)) return true;
        if (!rowValue && rowValue !== 0) return false;

        const value = parseFloat(rowValue);
        const min = headerValue.min !== null ? parseFloat(headerValue.min) : null;
        const max = headerValue.max !== null ? parseFloat(headerValue.max) : null;

        if (min !== null && max !== null) {
          return value >= min && value <= max;
        } else if (min !== null) {
          return value >= min;
        } else if (max !== null) {
          return value <= max;
        }
        return true;
      },
      formatter: (cell: CellComponent) => {
        const value = cell.getValue();
        if (value == null) return " - ";
        const data = value.toFixed(1);
        const temperatura = parseInt(data, 10);
        let temp;

        if (temperatura > 80) {
          temp = `<span><i class="ui icon thermometer full" style="color: #C71585; padding: 2px"></i>${data} ºC</span>`;
        } else if (temperatura > 70 && temperatura < 80) {
          temp = `<span><i class="ui icon thermometer half" style="color: gold; padding: 2px"></i>${data} ºC</span>`;
        } else {
          temp = `<span><i class="ui icon thermometer empty" style="color: aqua; padding: 2px"></i>${data} ºC</span>`;
        }

        return temp;
      },
    },
    {
      title: "Coordenadas (LAT/LONG)", // ALTERADO
      field: "Localizacao",
      formatter: (cell: CellComponent) => {
        const data = cell.getRow().getData();
        if (
          data.Latitude &&
          data.Longitude &&
          data.Latitude !== 0 &&
          data.Longitude !== 0
        ) {
          return `${data.Latitude}, ${data.Longitude}
                `;
        }
        return `${data.Latitude || " - "}`;
      },
      hozAlign: "center",
    },
  ];

  useEffect(() => {
    startApiCall();
    const initializeTable = async () => {
      if (!tableRef.current) return;

      if (mainTableRef.current) {
        mainTableRef.current.destroy();
        mainTableRef.current = null;
      }

      console.log("Inicializando tabela...");

      // 1. Obter nome da corporação para buscar configuração
      const corpObj = availableCorporations.find(c => c.id === selectedCorporation);
      const corporationName = corpObj ? corpObj.name : "";

      let colunasConfiguradas: any[] = [];

      // 2. Buscar configurações na API
      if (corporationName) {
        try {
          const response = await httpClient.request({
            method: RequestMethod.GET,
            endpoint: `/api/labels/TABELA_GATEWAYS/${corporationName}`
          });

          if (response.success && response.payload) {
            colunasConfiguradas = response.payload;
            console.log("Configurações de colunas carregadas:", colunasConfiguradas);
          }
        } catch (error) {
          console.error("Erro ao carregar labels:", error);
        }
      }

      // 3. Buscar cache de colunas (visibilidade + ordem) – Tabela_Gateways
      let columnsVisibility: Record<string, boolean> = {};
      let columnsOrder: string[] = [];
      if (cacheUserId) {
        try {
          const cacheResponse = await httpClient.request({
            method: RequestMethod.GET,
            endpoint: `/api/Cache/${SCREEN_CODE_TABELA_GATEWAYS}?userId=${cacheUserId}`,
          });
          const parsed = extractCacheJson(cacheResponse);
          if (parsed && typeof parsed === "object") {
            if (parsed.columnsVisibility && typeof parsed.columnsVisibility === "object") {
              columnsVisibility = parsed.columnsVisibility;
            }
            if (Array.isArray(parsed.columnsOrder)) {
              columnsOrder = parsed.columnsOrder;
            }
          }
        } catch (e) {
          console.warn("Cache de colunas (Tabela_Gateways) indisponível, usando padrão.", e);
        }
      }

      // 4. Obter colunas base e aplicar títulos (labels)
      const columns = getBaseColumns();
      const columnsWithTitles: ColumnDefinition[] = columns.map(col => {
        const config = colunasConfiguradas.find(
          c => c.Field && col.field && c.Field.toLowerCase() === col.field.toLowerCase()
        );
        if (config && config.Title) {
          return { ...col, title: config.Title };
        }
        return col;
      });

      // 5. Aplicar ordem do cache (columnsOrder) e visibilidade (columnsVisibility)
      const byField: Record<string, ColumnDefinition> = {};
      columnsWithTitles.forEach(c => { if (c.field) byField[c.field] = c; });
      const orderedColumns: ColumnDefinition[] = columnsOrder.length
        ? [
          ...columnsOrder.map(f => byField[f]).filter(Boolean),
          ...columnsWithTitles.filter(c => c.field && !columnsOrder.includes(c.field)),
        ]
        : columnsWithTitles;
      const finalColumns: ColumnDefinition[] = orderedColumns.map(col => ({
        ...col,
        visible: col.field !== undefined ? (columnsVisibility[col.field] ?? true) : true,
      }));

      mainTableRef.current = new Tabulator(tableRef.current, {
        data: [],
        height: 650,
        layout: "fitData",
        movableColumns: true,
        resizableColumnFit: true,
        columnHeaderVertAlign: "top",
        // Footer com contador traduzido à esquerda e paginador à direita
        footerElement: `<div style="display:flex;align-items:center;justify-content:flex-start;width:100%;gap:8px;">
      <div id="footer-info" style="margin-right:8px;color:#333;font-size:0.9em;"></div>
      <div id="footer-paginator" class="tabulator-paginator" style="display:flex;align-items:center;"></div>
    </div>`,
        // Paginação local (substitui o progressive scroll)
        pagination: true,
        paginationMode: "local",
        paginationSize: 25,
        paginationSizeSelector: [10, 25, 50, 100],
        paginationButtonCount: 5,
        // Suprime o contador interno do Tabulator retornando string vazia — usamos nosso #footer-info traduzido
        paginationCounter: (pageSize: number, currentRow: number, currentPage: number, totalRows: number, totalPages: number) => {
          return '';
        },
        renderVerticalBuffer: 300,
        keybindings: false,
        sortMode: "local",
        filterMode: "local",
        layoutColumnsOnNewData: false,
        placeholder: "Nenhum dado encontrado",
        debugInvalidOptions: false,
        debugEventsExternal: false,
        debugEventsInternal: false,
        initialSort: [],
        // Traduções e textos do paginador em português
        locale: true,
        langs: {
          "default": {
            pagination: {
              first: "Primeira",
              first_title: "Primeira Página",
              last: "Última",
              last_title: "Última Página",
              prev: "Anterior",
              prev_title: "Página Anterior",
              next: "Próxima",
              next_title: "Próxima Página",
              page_size: "Exibir",
              page_title: "Exibir página {page}",
              pagination: "Página",
              showing: "Mostrando",
              of: "de",
              to: "até",
              page: "página",
              // status format used by Tabulator for the pagination counter (fallback)
              status: "Mostrando {start} - {end} de {total} linhas",
            }
          }
        },
        columns: finalColumns
      });

      mainTableRef.current.on("tableBuilt", function () {
        console.log("Tabela construída");
        // Função para mover o paginador para o container do footer de forma segura
        const movePaginator = () => {
          try {
            const footerP = document.getElementById('footer-paginator');
            const footerEl = mainTableRef.current?.element?.querySelector('.tabulator-footer') || document.querySelector('.tabulator-footer');
            if (!footerEl) return false;

            // procura por qualquer paginador existente que não seja o container destino
            const paginator = document.querySelector('.tabulator-paginator:not(#footer-paginator)') || document.querySelector('.tabulator-paginator');

            if (paginator && footerP) {
              if (footerP !== paginator.parentElement) {
                footerP.innerHTML = '';
                footerP.appendChild(paginator);
              }
              return true;
            }

            // se não temos footerP, cria um no início do footer
            if (!footerP && footerEl) {
              const newP = document.createElement('div');
              newP.id = 'footer-paginator';
              newP.className = 'tabulator-paginator';
              newP.style.display = 'flex';
              newP.style.alignItems = 'center';
              footerEl.insertBefore(newP, footerEl.firstChild);
            }

            return false;
          } catch (err) {
            console.warn('Erro ao mover paginador para footer-paginator', err);
            return false;
          }
        };

        // Tenta mover imediatamente e novamente após pequeno delay para cobrir re-renders do Tabulator
        setTimeout(() => {
          if (isInitialized) {
            if (selectedOrganizations.length > 0) {
              console.log('🔄 Carregando dados iniciais para organizações:', selectedOrganizations);
              obterMapaGateway(selectedOrganizations);
            } else {
              console.log('🔄 Carregando dados iniciais sem filtro');
              obterMapaGateway();
            }
          } else {
            console.log('🔄 Carregando dados iniciais (filtros ainda não inicializados)');
            obterMapaGateway();
          }
        }, 100);
        if (!movePaginator()) {
          setTimeout(movePaginator, 120);

          const observer = new MutationObserver((mutations, obs) => {
            if (movePaginator()) {
              obs.disconnect();
            }
          });
          observer.observe(document.body, { childList: true, subtree: true });
          // desconecta após 2s para evitar overhead permanente
          setTimeout(() => observer.disconnect(), 2000);
        }
      });

      mainTableRef.current.on("dataLoaded", function (data: IGatewaysModel[]) {
        console.log("Dados carregados:", data.length, "registros");
        console.log("Total de registros no estado:", totalRegistros);
        console.log("Registros filtrados no estado:", registrosFiltrados);
        if (data.length > 0) {
          console.log('🔄 Atualizando filtros das colunas com', data.length, 'registros');

          // Atualiza as opções dos filtros
          const uniqueOrganizacoes = Array.from(new Set(data.map(item => item.Organizacao)))
            .filter(Boolean)
            .sort();

          const uniqueLocais = Array.from(new Set(data.map(item => item.Local)))
            .filter(Boolean)
            .sort();

          const uniqueGateways = Array.from(new Set(data.map(item => item.Gateway)))
            .filter(Boolean)
            .sort();

          const uniqueLocalDescricoes = Array.from(new Set(data.map(item => item.LocalDescricao)))
            .filter(Boolean)
            .sort();

          console.log('📊 Valores únicos encontrados:', {
            organizacoes: uniqueOrganizacoes.length,
            locais: uniqueLocais.length,
            gateways: uniqueGateways.length,
            localDescricoes: uniqueLocalDescricoes.length
          });

          // Atualiza as definições das colunas com os valores únicos
          try {
            mainTableRef.current.updateColumnDefinition("Organizacao", {
              headerFilterParams: {
                values: uniqueOrganizacoes,
                multiselect: true,
                clearable: true,
                sort: "asc"
              },
            });
            console.log('✅ Organizacao atualizada com', uniqueOrganizacoes.length, 'valores');

            mainTableRef.current.updateColumnDefinition("Local", {
              headerFilterParams: {
                values: uniqueLocais,
                multiselect: true,
                clearable: true,
                sort: "asc"
              },
            });
            console.log('✅ Local atualizada com', uniqueLocais.length, 'valores');

            mainTableRef.current.updateColumnDefinition("Gateway", {
              headerFilterParams: {
                values: uniqueGateways,
                multiselect: true,
                clearable: true,
                sort: "asc"
              },
            });
            console.log('✅ Gateway atualizada com', uniqueGateways.length, 'valores');

            mainTableRef.current.updateColumnDefinition("LocalDescricao", {
              headerFilterParams: {
                values: uniqueLocalDescricoes,
                multiselect: true,
                clearable: true,
                sort: "asc"
              },
            });
            console.log('✅ LocalDescricao atualizada com', uniqueLocalDescricoes.length, 'valores');

            console.log('✅ Todos os filtros atualizados com sucesso');
          } catch (error) {
            console.error('❌ Erro ao atualizar filtros:', error);
          }

          loadConfigTable();
          atualizarFooter();
        }
      });

      mainTableRef.current.on("dataFiltered", function (filters: any, rows: any[]) {
        console.log("Dados filtrados:", rows.length, "registros");
        console.log("Filtros ativos:", filters);
        setRegistrosFiltrados(rows.length);
        // Atualiza o footer com a contagem de registros
        atualizarFooter();
      });

      // Atualiza footer quando a página muda
      mainTableRef.current.on && mainTableRef.current.on('pageLoaded', function (pageno: number) {
        try { setTimeout(() => atualizarFooter(), 20); } catch (e) { }
      });

      mainTableRef.current.on("error", function (error: Error) {
        console.error("Erro na tabela:", error);
      });

      mainTableRef.current.on("rowClick", handleRowClick);
    }
    initializeTable();
    endApiCall();

  }, [selectedCorporation, cacheUserId]);

  // Efeito para atualizar o footer quando os contadores mudarem
  useEffect(() => {
    atualizarFooter();
  }, [totalRegistros, registrosFiltrados, atualizarFooter]);

  // Atualização dos dados
  useEffect(() => {
    if (mainTableRef.current && listaGateway.length > 0) {
      console.log("Atualizando dados da tabela:", listaGateway.length, "registros");

      mainTableRef.current.setData(listaGateway)
        .then(() => {
          console.log("Dados atualizados com sucesso");
          // Não sobrescrever registrosFiltrados aqui - deixar o dataFiltered event handler cuidar disso
        })
        .catch((error: Error) => {
          console.error("Erro ao atualizar dados:", error);
        });
    }
  }, [listaGateway]);

  // Adicionar um useEffect para atualizar o mapa quando mudar de aba
  useEffect(() => {
    if (activeTab === 'mapa' && selectedGateway && mapRef.current) {
      // Garantir que o grupo de marcadores existe
      if (!markersGroup.current && mapRef.current) {
        markersGroup.current = L.layerGroup().addTo(mapRef.current);
      }

      // Pequeno delay para garantir que o mapa está totalmente renderizado
      const timer = setTimeout(() => {
        addMarkerToMap(selectedGateway);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [activeTab, selectedGateway]);

  // Modificar o useEffect do selectedAlert para buscar comentários
  useEffect(() => {
    if (selectedAlert) {
      obterComentarios(selectedAlert.IdWorkFlow);
    }
  }, [selectedAlert]);

  const handleSettingsClick = () => {
    setSidebarVisible(!sidebarVisible);
    if (!sidebarVisible) {
      setTimeout(loadConfigTable, 300);
    }
  };
  const aplicarFiltros = async (organizations?: string[], gateways?: string[]) => {
    try {
      if (organizations && organizations.length > 0) {
        await obterMapaGateway(organizations);
      } else if (!organizations && !gateways) {
        await obterMapaGateway();
      }

      // Se houver gateways selecionados, filtrar os dados
      let dadosFiltrados = [...listaGateway];
      if (gateways && gateways.length > 0) {
        dadosFiltrados = dadosFiltrados.filter(item => gateways.includes(item.Gateway));
      }

      // Atualizar a tabela com os dados filtrados
      if (mainTableRef.current) {
        mainTableRef.current.setData(dadosFiltrados);
        setRegistrosFiltrados(dadosFiltrados.length);
      }
    } catch (error) {
      console.error("Erro ao aplicar filtros:", error);
    }
  };

  const applyConfigChanges = async () => {
    const updatedCols = configTableRefInstance.current.getData();

    const newColumns = updatedCols.map((col: any) => {
      const originalCol = mainTableRef.current.getColumn(col.field);
      if (originalCol) {
        const definition = originalCol.getDefinition();
        return {
          ...definition,
          visible: col.visible,
        };
      }
      return col;
    });

    mainTableRef.current.setColumns(newColumns);

    // Persistir visibilidade e ordem no cache Tabela_Gateways
    const visibility: Record<string, boolean> = {};
    const order: string[] = [];
    mainTableRef.current.getColumns().forEach((col: ColumnComponent) => {
      const field = col.getField();
      if (field) {
        visibility[field] = col.isVisible();
        order.push(field);
      }
    });
    await saveTableColumnsCache(visibility, order);
  };

  const handleDownloadCsv = () => {
    mainTableRef.current.download("csv", "gateways.csv");
  };

  // Função auxiliar para resetar filtros
  const resetHeaderFilters = () => {
    const columns = mainTableRef.current.getColumns();
    columns.forEach((column: any) => {
      const headerFilter = column.getHeaderFilterValue();
      if (headerFilter !== null && headerFilter !== undefined) {
        try {
          column.setHeaderFilterValue('');
        } catch (e) {
          console.log(`Erro ao limpar filtro da coluna ${column.getField()}:`, e);
        }
      }
    });
  };

  // Função simplificada para limpar filtros
  const handleClearFilters = () => {
    // Limpar gateway
    setSelectedGateways([]);

    // Limpar os filtros do cabeçalho da tabela
    if (mainTableRef.current) {
      const columns = mainTableRef.current.getColumns();
      columns.forEach((column: any) => {
        try {
          column.setHeaderFilterValue('');
        } catch (e) {
          console.log(`Erro ao limpar filtro da coluna ${column.getField()}:`, e);
        }
      });
    }
  };

  // Funções removidas - agora usa filtros globais
  // handleCorporationChange e handleOrganizationChange não são mais necessárias

  // Simplificar a função handleTabChange
  const handleTabChange = useCallback((tab: string) => {
    setActiveTab(tab);
  }, []);


  // Atualizar o estilo do card para remover o :hover inline
  const getCardStyle = (chamado: IChamado) => {
    return {
      backgroundColor: selectedAlert && selectedAlert.IdWorkFlow === chamado.IdWorkFlow ? '#e6f7ff' : '#f8f9fa',
      borderRadius: '8px',
      padding: '15px',
      marginBottom: '10px',
      color: '#000000',
      border: selectedAlert && selectedAlert.IdWorkFlow === chamado.IdWorkFlow ? '1px solid #91d5ff' : '1px solid #dee2e6',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      boxShadow: selectedAlert && selectedAlert.IdWorkFlow === chamado.IdWorkFlow ? '0 2px 8px rgba(0,123,255,0.15)' : '0 2px 4px rgba(0,0,0,0.05)'
    };
  };

  return (
    <div className="d-flex" style={{ position: "relative" }}>
      <div style={{ width: sidebarVisible ? "80%" : "100%", transition: "0.3s" }}>
        <h1 className="ui header">Tabela de gateways</h1>
        <div style={{ marginBottom: "10px", display: "flex", alignItems: "center", gap: "10px" }}>
          {/* Filtros Globais */}
          <div style={{ flex: 1, maxWidth: "600px" }}>
            <FiltroGlobal />
          </div>

          {/* Filtro de Gateways */}
          <div style={{ flex: 1, maxWidth: "300px" }}>
            <Select
              isMulti
              options={Array.from(new Set(listaGateway.map(g => g.Gateway)))
                .filter(Boolean)
                .sort()
                .map(gateway => ({ label: gateway, value: gateway }))}
              onChange={(selectedOptions: any) => {
                const selectedGateways = selectedOptions
                  ? selectedOptions.map((opt: any) => opt.value)
                  : [];
                if (mainTableRef.current) {
                  mainTableRef.current.setFilter("Gateway", "in", selectedGateways);
                }
              }}
              placeholder="Filtrar por Gateway"
              isClearable
              classNamePrefix="react-select"
            />
          </div>

          {/* Botão de Configurações */}
          <button
            onClick={handleSettingsClick}
            className="ui button primary"
            disabled={configButtonDisabled}
            title={configButtonDisabled ? "Aguardando carregamento das APIs..." : ""}
          >
            ⚙️ Configurações
          </button>
          {/* Botão para Limpar Filtros */}
          <button
            onClick={handleClearFilters}
            style={{ padding: "10px 20px", cursor: "pointer" }}
            className="ui button secondary"
          >
            🗑️ Limpar Filtros
          </button>
          {/* Botão de Download CSV */}
          <button
            onClick={handleDownloadCsv}
            style={{
              padding: "10px 20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
            className="ui button secondary"
          >
            <i className="ui icon arrow alternate circle down outline"></i>
            Download CSV
          </button>
          <button
            onClick={exportTableToExcel}
            style={{
              padding: "10px 20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
            className="ui button secondary"
          >
            <i className="ui icon file excel outline"></i>
            Download Excel
          </button>
          {/* Botão de Atualizar */}
          <button
            onClick={() => obterMapaGateway(selectedOrganizations)}
            style={{
              padding: "10px 20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
            className="ui button secondary"
          >
            <i className="ui icon refresh"></i>
            Atualizar
          </button>
        </div>
        {/* Tabela */}
        <div ref={tableRef}></div>
      </div>
      {/* Sidebar de Configurações */}
      {sidebarVisible && (
        <div className="sidebar-config">

          {/* Botão de Fechar (X) com classe CSS */}
          <i
            className="ui icon close sidebar-close-btn"
            onClick={() => setSidebarVisible(false)}
            title="Fechar configurações"
          />

          {/* Header ajustado: Removido 'inverted' para controlar via CSS */}
          <h4 className="ui grey header sidebar-header">
            <i className="ui cog icon"></i> Configurações da Tabela
          </h4>

          <div className="config-content" ref={configTableRef}></div>

          <button className="ui primary button" onClick={applyConfigChanges}>
            <i className="ui save icon"></i> Aplicar
          </button>
        </div>
      )}

      {/* Painel lateral de detalhes com abas estilizadas */}
      {detailsVisible && selectedGateway && (
        <div className="details-panel">
          <div className="header">
            <h3>Detalhes do Gateway</h3>
            <i
              className="ui close icon close-icon"
              onClick={() => {
                setDetailsVisible(false);
                mapRef.current = null;
                markersGroup.current = null;
                scaleControlRef.current = null;
                legendControlRef.current = null;
              }}
            />
          </div>

          {/* Menu de abas */}
          <div className="tab-container">
            <button
              className={`tab-button ${activeTab === 'mapa' ? 'active' : ''}`}
              onClick={() => handleTabChange('mapa')}
            >
              <i className="map icon"></i>
              Mapa
            </button>
            <button
              className={`tab-button ${activeTab === 'alertas' ? 'active' : ''}`}
              onClick={() => handleTabChange('alertas')}
            >
              <i className="bell icon"></i>
              Alertas
            </button>
          </div>

          {/* Conteúdo das abas */}
          <div className={`tab-content ${activeTab === 'mapa' ? 'active' : ''}`}>
            {activeTab === 'mapa' && (
              <div className="map-container">
                <MapContainer
                  center={
                    selectedGateway.Latitude && selectedGateway.Longitude
                      ? [selectedGateway.Latitude, selectedGateway.Longitude]
                      : [-14.235004, -51.92528]
                  }
                  zoom={selectedGateway.Latitude && selectedGateway.Longitude ? 15 : 4}
                  minZoom={5}
                  maxZoom={20}
                  className="map"
                  ref={(map) => {
                    if (map) {
                      mapRef.current = map;
                      if (markersGroup.current) {
                        map.removeLayer(markersGroup.current);
                      }
                      markersGroup.current = L.layerGroup().addTo(map);

                      if (scaleControlRef.current) {
                        map.removeControl(scaleControlRef.current);
                      }
                      const scaleControl = L.control.scale({
                        position: 'bottomleft',
                        metric: true,
                        imperial: false,
                      });
                      map.addControl(scaleControl);
                      scaleControlRef.current = scaleControl;

                      if (legendControlRef.current) {
                        map.removeControl(legendControlRef.current);
                      }
                      const LegendControl = L.Control.extend({
                        options: { position: 'bottomright' },
                        onAdd: function () {
                          const legendDiv = L.DomUtil.create('div', 'info-legend');
                          legendDiv.style.backgroundColor = 'white';
                          legendDiv.style.padding = '10px';
                          legendDiv.style.borderRadius = '5px';
                          legendDiv.style.boxShadow = '0 1px 5px rgba(0,0,0,0.4)';
                          legendDiv.innerHTML = `
                        <h4 style="margin: 0 0 10px 0; font-size: 14px; font-weight: bold;">Legenda</h4>
                        <div style="display: flex; flex-direction: column; gap: 8px;">
                            <div><div style="display: inline-block; width: 24px; height: 24px; border-radius: 50%; background-color: #1eaa00; border: 1px solid #ccc; vertical-align: middle;"></div> <span style="margin-left: 5px; vertical-align: middle;">Gateway Online</span></div>
                            <div><div style="display: inline-block; width: 24px; height: 24px; border-radius: 50%; background-color: #fb1404; border: 1px solid #ccc; vertical-align: middle;"></div> <span style="margin-left: 5px; vertical-align: middle;">Gateway Offline</span></div>
                        </div>`;
                          L.DomEvent.disableClickPropagation(legendDiv);
                          return legendDiv;
                        }
                      });
                      const legend = new LegendControl();
                      map.addControl(legend);
                      legendControlRef.current = legend;

                      if (selectedGateway?.Latitude && selectedGateway?.Longitude) {
                        addMarkerToMap(selectedGateway);
                        map.setView([selectedGateway.Latitude, selectedGateway.Longitude], 15);
                      } else {
                        map.setView([-14.235004, -51.92528], 4);
                      }
                    }
                  }}
                >
                  {/* Camada padrão - Satélite Google (igual ao MenuAtivoMapa) */}
                  <TileLayer
                    url="https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                    maxZoom={20}
                    maxNativeZoom={20}
                    tileSize={256}
                    zoomOffset={0}
                    updateWhenZooming={false}
                    keepBuffer={2}
                    updateWhenIdle={true}
                    eventHandlers={{
                      tileerror: (e) => {
                        console.warn('⚠️ Erro ao carregar tile:', e);
                        // Não fazer nada - o Leaflet já trata automaticamente
                      }
                    }}
                  />

                  {/* Controle de Camadas Base (igual ao MenuAtivoMapa) */}
                  <LayersControl position="topright">
                    <LayersControl.BaseLayer checked name="Satélite Google">
                      <TileLayer
                        url="https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                        maxZoom={20}
                        maxNativeZoom={20}
                        tileSize={256}
                        zoomOffset={0}
                        updateWhenZooming={false}
                        keepBuffer={2}
                        updateWhenIdle={true}
                      />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Viário Google">
                      <TileLayer
                        url="https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
                        maxZoom={20}
                        maxNativeZoom={20}
                        tileSize={256}
                        zoomOffset={0}
                        updateWhenZooming={false}
                        keepBuffer={2}
                        updateWhenIdle={true}
                      />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="OpenStreetMap">
                      <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        maxZoom={18}
                        maxNativeZoom={18}
                        tileSize={256}
                        zoomOffset={0}
                        updateWhenZooming={false}
                        keepBuffer={2}
                        updateWhenIdle={true}
                      />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Mapa Escuro">
                      <TileLayer
                        url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
                        attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors &copy; <a href='https://carto.com/attributions'>CARTO</a>"
                        maxZoom={18}
                        maxNativeZoom={18}
                        tileSize={256}
                        zoomOffset={0}
                        updateWhenZooming={false}
                        keepBuffer={2}
                        updateWhenIdle={true}
                      />
                    </LayersControl.BaseLayer>
                  </LayersControl>
                </MapContainer>
              </div>
            )}
          </div>

          <div className={`tab-content ${activeTab === 'alertas' ? 'active' : ''}`}>
            {activeTab === 'alertas' && (
              <div className="alert-details">
                <div className="alert-list">
                  {chamadosGateway.length > 0 ? (
                    [...chamadosGateway]
                      .sort((a, b) => new Date(b.DataCriacao).getTime() - new Date(a.DataCriacao).getTime())
                      .map((chamado, index) => (
                        <div
                          key={index}
                          className={`alert-card ${selectedAlert && selectedAlert.IdWorkFlow === chamado.IdWorkFlow ? 'selected' : ''}`}
                          onClick={() => setSelectedAlert(chamado)}
                        >
                          <div className="alert-header">
                            <div className="alert-icons">
                              {chamado.Status ? (
                                <i className="ui small green check icon" title="Concluído" />
                              ) : (
                                <i className="ui small clock icon" title="Em andamento" />
                              )}
                              {(() => {
                                switch (parseInt(chamado.IdAlertLevel)) {
                                  case 1:
                                  case 2:
                                    return <i className="ui small yellow exclamation triangle icon" title="Alerta Baixo" />;
                                  case 3:
                                    return <i className="ui small orange exclamation triangle icon" title="Alerta Médio" />;
                                  case 4:
                                  case 5:
                                    return <i className="ui small red exclamation triangle icon" title="Alerta Alto" />;
                                  default:
                                    return <i className="ui small gray exclamation triangle icon" title="Nível não definido" />;
                                }
                              })()}
                            </div>
                            <span className="alert-date">
                              {moment(chamado.DataCriacao).subtract(3, 'hours').format('DD/MM/YYYY HH:mm')}
                            </span>
                          </div>
                          <div className="alert-title">{chamado.Assunto}</div>
                          <div className="alerta-info">
                            <div>Requisitante: {chamado.UsuarioOwner}</div>
                            <div>Responsável: {chamado.UsuarioResponsible}</div>
                          </div>
                          <div className="alert-footer">
                            <span>Chamado: {chamado.Chamado ? `#${chamado.Chamado}` : 'Não registrado'}</span>
                            <div className="alert-actions">
                              <div className="comment-count">
                                <i className="ui icon comment alternate" title="Interações" />
                                {(chamado.TotalRecords ?? 0) > 0 && (
                                  <div className="count-badge">{chamado.TotalRecords}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                  ) : (
                    <div className="no-alerts">
                      Não há alertas registrados para este ativo
                    </div>
                  )}
                </div>

                <div className="comment-section">
                  {selectedAlert && (
                    <div className="comment-box">
                      <h4>Comentários</h4>
                      <div className="comments">
                        {coments
                          .sort((a, b) => new Date(b.DtCriacao).getTime() - new Date(a.DtCriacao).getTime()) // Ordena do mais recente para o mais antigo
                          .map((comentario, index) => (
                            <div key={index} className="comment">
                              <div>{comentario.Comments}</div>
                              <div>
                                Por {comentario.Name || 'Usuário não identificado'} em{' '}
                                {moment(comentario.DtCriacao).subtract(3, 'hours').format('DD/MM/YYYY HH:mm')}
                              </div>
                            </div>
                          ))}
                      </div>
                      <textarea
                        placeholder="Digite seu comentário..."
                        value={newComment}
                        onChange={(e) => setNewComment(e.target.value)}
                        disabled={selectedAlert.Status === true}
                      />
                      <div style={{ display: "flex", gap: "8px", marginTop: "8px", justifyContent: "center" }}>
                        <button
                          className="ui primary button"
                          onClick={() => {
                            if (selectedAlert.Status !== true) {
                              handleIncluirComentario();
                            }
                          }}
                          disabled={selectedAlert.Status === true}
                          style={{
                            cursor: selectedAlert.Status === true ? "not-allowed" : "pointer",
                            backgroundColor: selectedAlert.Status === true ? "#d3d3d3" : "",
                            padding: "8px 12px", // metade do tamanho
                            fontSize: "0.9em",
                          }}
                        >
                          {selectedAlert.Status === true ? "Chamado Fechado" : "Adicionar Comentário"}
                        </button>
                        {selectedAlert?.IdUsuarioResponsible === idemail && !selectedAlert?.Status && (
                          <button
                            title={coments.length === 0 ? "É necessário incluir ao menos um comentário para fechar o alerta." : ""}
                            style={{
                              padding: "8px 12px",
                              backgroundColor: "#fd2600",
                              color: "#fff",
                              border: "none",
                              borderRadius: "5px",
                              fontSize: "0.9em",
                              transition: "opacity 0.3s",
                              cursor: coments.length === 0 ? "not-allowed" : "pointer",
                              opacity: coments.length === 0 ? 0.6 : 1,
                            }}
                            disabled={coments.length === 0}
                            onClick={() => handleFecharChamado(parseInt(selectedAlert.IdWorkFlow))}
                          >
                            Fechar Chamado
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default GatewayTable;
